import { render, staticRenderFns } from "./PortEditStaff.vue?vue&type=template&id=505dd38a&scoped=true"
import script from "./PortEditStaff.vue?vue&type=script&lang=js"
export * from "./PortEditStaff.vue?vue&type=script&lang=js"
import style0 from "./PortEditStaff.vue?vue&type=style&index=0&id=505dd38a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "505dd38a",
  null
  
)

export default component.exports